import React, { Fragment } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Container } from "reactstrap"
import { Filter, DefaultColumnFilter } from "../Components/filters"

// Define a default UI for filtering

const ManageSettingsTableContainer = ({
  columns,
  data,
  onHeaderClick,
  customPageSize,
  customPageSizeOptions,
  handlePageValue,
  totalCount,
  pageindex,
  widthControl,
  isMobile,
  noPagination
}) => {
  const hidden = []
  columns.map(el => {
    if (el?.hidden == true) {
      hidden.push(el.accessor)
    }
  })
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    footerGroups,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      onHeaderClick: Function,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: pageindex,
        pageSize: customPageSize,
        hiddenColumns: hidden,
        // sortBy: [
        //   {
        //     desc: true,
        //   },
        // ],
      },
      manualPagination: true,
      manualSortBy: true,
      pageCount: Math.ceil(totalCount / customPageSize),
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const generateSortingIndicator = column => {
    return column.sort ? (
      <i
        className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}
      ></i>
    ) : (
      ""
    )
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
    handlePageValue({
      pageSize: Number(event.target.value),
      pageNumber: 0,
      noChange: true,
    })
  }
  const handlenext = data => {
    // setpageValueSet(pageIndex + 1)
    nextPage(data)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageIndex + 1,
    })
  }
  const handleprev = () => {
    previousPage()
    handlePageValue({
      pageSize: pageSize,
      pageNumber: pageIndex - 1,
    })
  }
  const handlestartpage = () => {
    gotoPage(0)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: 0,
    })
  }
  const handlelastpage = () => {
    gotoPage(pageCount - 1)
    handlePageValue({
      pageSize: pageSize,
      pageNumber: Math.ceil(totalCount / pageSize) - 1,
    })
  }

  const onChangeInInput = event => {
    if (pageCount - 1 >= event.target.value) {
      const page = event.target.value > 0 ? Number(event.target.value) - 1 : 0
      //setpageValueSet(pageIndex +1)
      gotoPage(page)
      handlePageValue({
        pageSize: pageSize,
        pageNumber: page,
      })
    }
  }

  return (
    <Fragment>
      <div className="table-responsive react-table ">
        <Table bordered hover {...getTableProps()}>
          <thead className="table-light table-center">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => onHeaderClick(column, pageSize, pageIndex)}
                  >
                    <div
                      className={widthControl ? "mb-2 widthControl" : "mb-2"}
                      {...column.getSortByToggleProps()}
                    >
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                    <Filter column={column} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <>
            {page.length > 0 && (
              <>
                {!isMobile ? (
                  <tfoot>
                    {footerGroups.map(group => (
                      <tr {...group.getFooterGroupProps()} key={group.id}>
                        {group.headers.map(column => (
                          <td
                            {...column.getFooterProps()}
                            key={group.id}
                            data-label={
                              column?.Footer?.length !== 0 && column?.Header
                            }
                          >
                            {column.render("Footer")}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tfoot>
                ) : (
                  <tfoot>
                    {footerGroups.map(group => (
                      <>
                        <div className="p-2 font-weight-bold text-center text-uppercase">
                          Total Hours
                        </div>
                        <tr {...group.getFooterGroupProps()} key={group.id}>
                          {group.headers.map(column => (
                            <>
                              {column?.footerType == true &&
                                column?.totalType == false && (
                                  <td
                                    {...column.getFooterProps()}
                                    key={group.id}
                                    data-label={
                                      column?.Footer?.length !== 0 &&
                                      column?.Header
                                    }
                                  >
                                    {column.render("Footer")}
                                  </td>
                                )}
                            </>
                          ))}
                        </tr>
                      </>
                    ))}
                  </tfoot>
                )}
              </>
            )}
          </>

          <tbody {...getTableBodyProps()}>
            {(page.length > 0 &&
              page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr style={{ cursor: "pointer" }} {...row.getRowProps()}>
                      {row.cells.map(cell => {
                        return (
                          <td
                            key={cell.id}
                            {...cell.getCellProps()}
                            data-label={cell?.column?.Header}
                            style={{
                              paddingBottom:
                                cell?.column?.paddingBottom &&
                                cell?.column?.paddingBottom,
                              minWidth: cell?.column?.width && cell?.column?.width,
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })) || (
              <tr>
                <td
                  colSpan={headerGroups[0]?.headers?.length}
                  className="react-bs-table-no-data p-5 text-center"
                >
                  Sorry, There are no data to display
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {!noPagination && <div className="pagination justify-content-end customiz_pagination">
        {data.length > 0 && (
          <Col sm={customPageSizeOptions ? 2 : 2} className="me-3 p-2">
            <select
              className="form-select p-2"
              value={pageSize}
              onChange={onChangeInSelect}
            >
              {[10, 20, 30, 40, 50].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )}

        {data.length > 0 && (
          <div className="paginations d-flex justify-content-end align-items-center">
            <Container>
              <Row className=" align-items-center">
                <Col className="col-md-auto">
                  <div className="d-flex gap-1">
                    <Button
                      color="primary"
                      onClick={handlestartpage}
                      disabled={!canPreviousPage}
                    >
                      {"<<"}
                    </Button>{" "}
                    <Button
                      color="primary"
                      onClick={handleprev}
                      disabled={!canPreviousPage}
                    >
                      {"<"}
                    </Button>{" "}
                  </div>
                </Col>
                <Col className="col-md-auto d-none d-md-block">
                  <span>
                    Page{" "}
                    <strong>
                      {pageindex + 1} of {Math.ceil(totalCount / pageSize)}
                    </strong>{" "}
                  </span>
                </Col>
                <Col className="col-md-auto">
                  <span>
                    | Go to page:{" "}
                    <input
                      type="number"
                      value={pageindex + 1}
                      onChange={onChangeInInput}
                      style={{ width: "50px", textAlign: "center" }}
                    />
                  </span>
                </Col>
                <Col className="col-md-auto">
                  <div className="d-flex gap-1">
                    <Button
                      color="primary"
                      onClick={handlenext}
                      disabled={
                        !canNextPage ||
                        pageIndex >= Math.ceil(totalCount / pageSize) - 1
                      }
                    >
                      {">"}
                    </Button>{" "}
                    <Button
                      color="primary"
                      onClick={handlelastpage}
                      disabled={
                        !canNextPage ||
                        pageIndex >= Math.ceil(totalCount / pageSize) - 1
                      }
                    >
                      {">>"}
                    </Button>{" "}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </div>}
    </Fragment>
  )
}

ManageSettingsTableContainer.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default ManageSettingsTableContainer
